/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitGetEntityDomainsEmailAggQueries
 */
export interface MonitGetEntityDomainsEmailAggQueries {
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityDomainsEmailAggQueries
     */
    process_id?: string;
}

/**
 * Check if a given object implements the MonitGetEntityDomainsEmailAggQueries interface.
 */
export function instanceOfMonitGetEntityDomainsEmailAggQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitGetEntityDomainsEmailAggQueriesFromJSON(json: any): MonitGetEntityDomainsEmailAggQueries {
    return MonitGetEntityDomainsEmailAggQueriesFromJSONTyped(json, false);
}

export function MonitGetEntityDomainsEmailAggQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitGetEntityDomainsEmailAggQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
    };
}

export function MonitGetEntityDomainsEmailAggQueriesToJSON(value?: MonitGetEntityDomainsEmailAggQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'process_id': value.process_id,
    };
}

